<template>
    <q-layout>
        <q-header :class="darkMode ? 'bg-dark' : ''" class="header-container q-pa-md" elevated>
            <div class="row justify-between items-center q-gutter-md" :style="{ color: darkMode ? 'white' : 'inherit' }" style="width: 100%">
                <q-img :src="darkMode ? '/img/OnSightLogoDark.png' : '/img/OnSightLogo150px.png'" alt="OnSight Logo" :style="{
                    width: isLargeScreen ? '150px' : '150px',
                    height: isLargeScreen ? 'auto' : 'auto',
                }" />
                <div v-if="isLargeScreen" class="buttons-container row justify-end items-center q-gutter-md">
                    <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'brand'" size="1.75em" to="/"
                        label="Home" />
                    <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'brand'" size="1.75em" to="/about"
                        label="About" />
                    <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'brand'" size="1.75em" to="/team"
                        label="Team" />
                    <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'brand'" size="1.75em" to="/press"
                        label="Press" />
                    <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'brand'" size="1.75em" to="/contact"
                        label="Contact Us" />

                    <q-btn-dropdown no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'brand'" size="1.75em"
                        label="Training">
                        <q-list>
                            <q-item clickable v-close-popup>
                                <q-item-section style="
                                        width: 150px;
                                        height: auto;
                                        position: relative;
                                    ">
                                    <q-item-label>
                                        <a href="https://myapps.microsoft.com/signin/a655ab7c-44dc-4d68-a618-751f1d1839b3?tenantId=620cf8c2-311f-4648-a775-3188cd1023fe"
                                            target="_blank">
                                            <q-img :src="darkMode ? '/img/leonardo_logo_Dark.png' : '/img/Leonardo_logo.jpg'" alt="Leonardo image" style="
                                                    width: 150px;
                                                    height: auto;
                                                    z-index: -1;
                                                " />
                                        </a>
                                    </q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-btn-dropdown>
                    <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'brand'" size="1.75em" to="/portal"
                        label="Optician Portal" />

                    <!-- DARK MODE-->
          
                    <q-btn icon="brightness_6" no-caps flat unelevated size="1.25em" @click="toggleDarkMode"
                        :text-color="darkMode ? 'grey-7' : 'brand'" />

                    <!-- END DARK MODE-->
                </div>
      
                <div v-else class="row items-center">
                    <q-btn icon="brightness_6" no-caps flat unelevated size="1em" @click="toggleDarkMode"
                        :text-color="darkMode ? 'grey-6' : 'brand'" />
                    <q-btn class="menu-btn" icon="menu" flat round dense :text-color="darkMode ? 'grey-6' : 'brand'" @click="drawer = !drawer" />
                </div>
            </div>
        </q-header>
        <q-drawer v-model="drawer" side="left" overlay behavior="mobile" show-if-above>
            <q-list>
                <q-item clickable v-ripple to="/">
                    <q-item-section :class="darkMode ? 'text-grey-6' : 'text-brand'" style="font-size: 1.5em">Home</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/about">
                    <q-item-section :class="darkMode ? 'text-grey-6' : 'text-brand'" style="font-size: 1.5em">About</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/team">
                    <q-item-section :class="darkMode ? 'text-grey-6' : 'text-brand'" style="font-size: 1.5em">Team</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/press">
                    <q-item-section :class="darkMode ? 'text-grey-6' : 'text-brand'" style="font-size: 1.5em">Press</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/contact">
                    <q-item-section :class="darkMode ? 'text-grey-6' : 'text-brand'" style="font-size: 1.5em">Contact Us</q-item-section>
                </q-item>
            </q-list>
        </q-drawer>
        <q-page-container>
            <slot />
        </q-page-container>
        <q-footer :class="darkMode ? 'bg-dark text-grey-5' : 'bg-brand text-white'">
            <div class="row justify-center">
                <div class="col-12 col-md-4 text-center q-mb-md q-mt-md">
                    <div class="text-h4">Our Office</div>
                    <br />
                    <div class="q-pt-none q-mt-auto">
                        <p class="text-center" style="font-size: 20px">
                            2120 Calumet St. Suite 3 <br />
                            Clearwater, FL 33765<br />
                        </p>
                    </div>
                </div>

                <div class="col-12 col-md-4 text-center q-mb-md q-mt-md">
                    <div class="text-h4">Hours of Operation</div>
                    <br />
                    <div class="q-pt-none q-mt-auto">
                        <p class="text-center" style="font-size: 20px">
                            8:30AM - 5PM EST, Mon to Fri
                        </p>
                    </div>
                </div>

                <div class="col-12 col-md-4 text-center q-mb-md q-mt-md">
                    <div class="text-h4">Contact</div>
                    <br />
                    <div class="q-pt-none q-mt-auto">
                        <p class="text-center" style="font-size: 20px">
                            information@onsightoptical.com <br />
                            (727) 461-4657
                        </p>
                    </div>
                </div>
            </div>
        </q-footer>
    </q-layout>
</template>

<script setup>
import { ref, computed } from "vue";
import { useQuasar } from "quasar";

const drawer = ref(false);
const $q = useQuasar();

const isLargeScreen = computed(() => $q.screen.gt.xs);

const darkMode = ref($q.dark.isActive);

const toggleDarkMode = () => {
    $q.dark.set(!darkMode.value);
    darkMode.value = !darkMode.value;
};

const darkModeLabel = computed(() => (darkMode.value ? 'Light Mode' : 'Dark Mode'));




</script>

<style scoped>
.header-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    margin: 15px auto;
    border-bottom: 4px solid #000f55;
    background-color: transparent;
}

.menu-btn {
    margin-left: auto;
}
</style>
